import React, { PureComponent } from 'react'
import styled from 'styled-components'
import Proton from 'proton-js'

import { connect } from 'react-redux'

import { IStore } from '../../redux/reducers/index'

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
`

const CanvasElement = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0);
`

interface IParticlesProps {
	particle: string
	particleSystem: any
	path: string
}

class Particles extends PureComponent<IParticlesProps> {
	private container: HTMLDivElement = document.createElement('div')
	private intervalId = 0
	private proton: any

	formatValue = (value: number | string) => {
		if (typeof value === 'number') {
			return value
		} else {
			if (value === '[WIDTH]') {
				return this.container.clientWidth
			} else if (value === '[HEIGHT]') {
				return this.container.clientHeight
			} else if (value === '[INFINITY]') {
				return Infinity
			}
		}
	}

	componentDidMount() {
		const canvas = this.container
		const proton = new Proton()
		const emitter = new Proton.Emitter()

		////
		const particleSystem = this.props.particleSystem
		////

		//set Rate
		emitter.rate = new Proton.Rate(this.formatValue(particleSystem.rate[0]), this.formatValue(particleSystem.rate[1]))
		emitter.damping = this.formatValue(particleSystem.damping)

		//add Initialize
		emitter.addInitialize(new Proton.Body([this.props.path + this.props.particle], 100, 100))
		emitter.addInitialize(new Proton.Life(this.formatValue(particleSystem.life)))
		emitter.addInitialize(new Proton.Mass(this.formatValue(particleSystem.mass)))

		const emitterZone = particleSystem.emitterZone
		emitter.addInitialize(
			new Proton.Position(
				new Proton.RectZone(
					this.formatValue(emitterZone[0]),
					this.formatValue(emitterZone[1]),
					this.formatValue(emitterZone[2]),
					this.formatValue(emitterZone[3])
				)
			)
		)
		if (particleSystem.velocity) {
			const velocity = particleSystem.velocity
			if (velocity.type.name === 'polar') {
				emitter.addInitialize(
					new Proton.Velocity(
						this.formatValue(velocity.value),
						Proton.getSpan(this.formatValue(velocity.type.span[0]), this.formatValue(velocity.type.span[1])),
						'polar'
					)
				)
			} else if (velocity.type.name === 'linear') {
				emitter.addInitialize(
					new Proton.Velocity(
						this.formatValue(velocity.value),
						Proton.getSpan(this.formatValue(velocity.type.span[0]), this.formatValue(velocity.type.span[1])),
						'linear'
					)
				)
			}
		}

		if (particleSystem.crossZone && particleSystem.crossZone.type === 'bound') {
			const rectZone = particleSystem.crossZone.rectZone
			emitter.addBehaviour(
				new Proton.CrossZone(
					new Proton.RectZone(
						this.formatValue(rectZone[0]),
						this.formatValue(rectZone[1]),
						this.formatValue(rectZone[2]),
						this.formatValue(rectZone[3])
					),
					'bound'
				)
			)
		}

		//add Behaviour
		if (particleSystem.scale) {
			emitter.addBehaviour(
				new Proton.Scale(this.formatValue(particleSystem.scale[0]), this.formatValue(particleSystem.scale[1]), Infinity)
			)
		}
		if (particleSystem.rotate) {
			emitter.addBehaviour(new Proton.Rotate(this.formatValue(particleSystem.rotate.value[0])))
		}

		emitter.emit(this.formatValue(particleSystem.emissions))

		//add emitter to the proton
		proton.addEmitter(emitter)

		// add canvas renderer
		const renderer = new Proton.DomRenderer(canvas)
		proton.addRenderer(renderer)

		//use Euler integration calculation is more accurate (default false)
		Proton.USE_CLOCK = true

		this.intervalId = window.setInterval(() => {
			proton.update()
		}, 50)
	}

	render() {
		return (
			<Wrapper>
				<CanvasElement
					ref={(elem: HTMLDivElement) => {
						this.container = elem
					}}
				></CanvasElement>
			</Wrapper>
		)
	}

	componentWillUnmount() {
		window.clearInterval(this.intervalId)
		if (this.proton) {
			this.proton.destroy()
		}
	}
}

const mapStateToProps = (state: IStore) => {
	return {
		path: state.app.config.assets_path || '/',
	}
}

export default connect(mapStateToProps)(Particles)
